import { collection } from 'firebase/firestore';

import { CollectionOptions } from './collection-options';
import { getDatabase } from './get-database';

export const getCollection = (collectionName: CollectionOptions) => {
  return collection(getDatabase(), collectionName);
};
